import { SINGLE_OWNER_PAGE } from "../../constants";
import { SET_GOOD_LUCK_MESSAGES } from "../actionTypes/FundraiserTypes";

const initialState = {
    anchor: 'left',
    fundraiser_pages: [],
    id: '',
    fundraiser_page_title: '',
    fundraiser_goal: '',
    fundraiser_currency: '',
    is_ind_or_team: '',
    fundraiser_campaign: '',
    fundraiser_occasions: '',
    campaign_duration: '',
    is_private: '',
    reason_for_raising: '',
    cover_photo: '',
    fundraiser_link: '',
    campaign_id: '',
    campaign_name: '',
    occasion_name: '',
    currency_name: '',
    users_except_lead: '',
    team: '',
    recentDonations: {},
    highestDonations: {},
    get_teams_fund_stat: '',
    countries: '',
    is_loading: false,
    fundraiser_pages_data: [],
    fundraiser_pages_data_total_records: 0,
    past_fundraiser_page: [],
    countries_with_currencies: '',
    event_id: '',
    redux_loader: false,
    loader_state_thankyou: false,
    user_fundraiser_pages_data: [],
    user_fundraiser_pages_data_total_records: 0,
    user_team_fundraiser_pages_data: [],
    user_team_fundraiser_pages_data_total_records: 0,
    fundraiser_page_updates_images: [],
    fundraiser_page_updates: [],
    fundraiser_details: undefined,
    userFundraisers: {
        personalPages: null,
        teamPages: null
    },
    pageMessages: {
        messages: [],
        total: 0
    },
    fundraisers_by_campaign: {
        pages: [],
        total: 0
    },
    campaigns: {
        campaigns: []
    },
    occasions: {
        occasions: []
    },
    default_images: []
};


export function fundraiser_page(state = initialState, action) {
    switch (action.type) {
        case SET_GOOD_LUCK_MESSAGES:
            return {
                ...state,
                pageMessages: {
                    total: action.response.total,
                    messages: !action.payloadOffset ?
                        action.response.good_luck_messages :
                        [...state.pageMessages.messages, ...action.response.good_luck_messages],
                }
            }
        case 'FETECHED_ALL_FUNDRAISER_PAGES':
            if (action.is_search_request == 1) {
                state.fundraiser_pages_data = [];
            }
            state.fundraiser_pages_data.push(action.fundraiser_pages_list);
            state.fundraiser_pages_data_total_records = action.fundraiser_pages_list.total;
            state.redux_loader = false;
            return {
                ...state,
                fundraiser_pages_list: action.fundraiser_pages_list
            };
        case 'FUNDRAISER_PAGE_DETAIL':
            return {
                ...state,
                fundraiser_details: action.fundraiser_details
            };
        case 'UPDATE_TEAM':
            return {
                ...state,
                fundraiser_details: {
                    ...state.fundraiser_details,
                    team_members: [
                        ...action.team
                    ]
                }
            }
        case "FUNDRAISER_PAGE_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        case 'FUNDRAISER_PAGES_BY_USER':
            const { pageType, data } = action;
            let list = {
                ...state.userFundraisers
            }
            pageType == SINGLE_OWNER_PAGE ?
                list = {
                    ...list,
                    personalPages: data
                } :
                list = {
                    ...list,
                    teamPages: data
                }
            return {
                ...state,
                userFundraisers: list
            }

        case 'FUNDRAISER_PAGE_UPDATES_IMAGES':
            state.fundraiser_page_updates_images.push(action.page_updates_images);
            return {
                ...state,
                page_updates_images: action.page_updates_images
            };
        case 'FETECHED_ALL_TEAM_MEMBERS_COUNT':
            return {
                ...state,
                team_count: action.team_count
            };
        case 'FETECHED_FUNDRAISER_DONATIONS_COUNT':
            return {
                ...state,
                donations_count: action.donations_count
            };
        case 'FETECHED_TEAM_MEMBER':
            return {
                ...state,
                team_member: action.team_member
            };
        case 'FETECHED_ALL_FUNDRAISER_PAGE_DEFAULT_IMAGES':
            return {
                ...state,
                default_images: action.default_images
            };
        case 'FETECHED_FUNDRAISER_LISTING_PAGE_COUNTS':
            return {
                ...state,
                listing_page_counts: action.listing_page_counts
            };
        case 'FETECHED_USER_DEFAULT_CURRENCY':
            return {
                ...state,
                location_details: action.location_details
            };
        case 'FETECHED_FUNDRAISER_SHARE_COUNT':
            return {
                ...state,
                social_count: action.social_count
            };
        case 'GET_MIN_MAX_GOAL_RANGE':
            return {
                ...state,
                min_max_range: action.min_max_range
            };
        case 'INTIMATE_FUNDRAISER_PAGE_CREATION':
            return {
                ...state,
                status: action.status
            };
        case 'UPDATE_LOADER_STATE':
            state.redux_loader = action.loader_state;
            return {
                ...state
            };
        case 'UPDATE_LOADER_STATE_THANKYOU':
            state.loader_state_thankyou = action.loader_state_thankyou;
            return {
                ...state
            };
        case 'CAMPAIGN_DETAILS':
            return {
                ...state,
                campaign_details: action.campaign_details
            };
        case 'FUNDRAISERS_BY_CAMPAIGN':
            const response = action.fundraisers_by_campaign

            if (action.offset > 0)
                return {
                    ...state,
                    fundraisers_by_campaign: {
                        pages: [...state.fundraisers_by_campaign.pages, ...response.result],
                        total: response.total
                    }
                };
            return {
                ...state,
                fundraisers_by_campaign: {
                    pages: response.result,
                    total: response.total
                }
            };

        case 'FUNDRAISER_PAGE_UPDATES':
            state.redux_loader = false;
            if (action.request_type == 1) {
                state.fundraiser_page_updates_images = [];
                state.fundraiser_page_updates = action.page_updates;
            }
            else state.fundraiser_page_updates.updates = [...state.fundraiser_page_updates.updates, ...action.page_updates.updates]
            return {
                ...state,
                page_updates: action.page_updates
            };
        case 'TOP_FUNDRAISERS_IMPACTED':
            return {
                ...state,
                top_fundraisers_impacted: action.top_fundraisers_impacted
            };
        case 'TOP_TEAMS_IMPACTED':
            return {
                ...state,
                top_teams_impacted: action.top_teams_impacted
            };
        case 'RESET_FUNDRAISER_LIST':
            state.fundraiser_pages_data = [];
            state.fundraiser_pages = [];
            state.fundraiser_pages_data = [];
            state.past_fundraiser_page = [];
            state.user_fundraiser_pages_data = [];
            state.user_team_fundraiser_pages_data = [];
            state.fundraiser_page_updates_images = [];
            state.fundraiser_page_updates = [];
            state.id = '';
            state.fundraiser_page_title = '';
            state.fundraiser_goal = '';
            state.fundraiser_currency = '';
            state.is_ind_or_team = '';
            state.fundraiser_campaign = '';
            state.fundraiser_occasions = '';
            state.campaign_duration = '';
            state.is_private = '';
            state.reason_for_raising = '';
            state.cover_photo = '';
            state.fundraiser_link = '';
            state.campaign_id = '';
            state.campaign_name = '';
            state.occasion_name = '';
            state.currency_name = '';
            state.users_except_lead = '';
            state.team = '';
            state.donors = '';
            state.get_teams_fund_stat = '';
            state.countries = '';
            state.is_loading = false;
            state.fundraiser_pages_data_total_records = 0;
            state.countries_with_currencies = '';
            state.event_id = '';
            state.redux_loader = false;
            state.user_fundraiser_pages_data_total_records = 0;
            state.user_team_fundraiser_pages_data_total_records = 0;
            //state.fundraiser_details = '';
            return state;
        default:
            return state
    }
}

export function past_fundraiser_page(state = initialState, action) {
    switch (action.type) {
        case 'PAST_FUNDRAISER_PAGES_BY_USER':
            return {
                past_fundraiser_pages_by_user: action.past_fundraiser_pages_by_user
            };
        default:
            return state
    }
}

export function campaigns(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_CAMPAIGNS':
            return {
                ...state,
                campaigns: action.campaigns
            };
        case 'CAMPAIGNS':
            return {
                ...state,
                id: action.id,
                name: action.campaign_name
            };
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}

export function occasions(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_OCCASIONS':
            return {
                ...state,
                occasions: action.occasions
            };
        case 'OCCASIONS':
            return {
                ...state,
                id: action.id,
                name: action.occasion_name
            };
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}

export function currencies(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_CURRENCIES':
            return {
                ...state,
                currencies: action.currencies
            };
        case 'CURRENCIES':
            return {
                ...state,
                id: action.id,
                name: action.currency_name
            };
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}

export function countries(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_COUNTRIES':
            return {
                ...state,
                countries: action.countries
            };
        case 'FETECHED_ALL_COUNTRIES_WITH_CURRENCIES':
            return {
                ...state,
                countries_with_currencies: action.countries_with_currencies
            };
        case 'FETECHED_ALL_COUNTRIES_WITHOUT_PARTNERS':
            return {
                ...state,
                countries_without_partners: action.countries_without_partners
            };
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}

export function validate_fd_page_title(state = initialState, action) {
    switch (action.type) {
        case 'VALIDATE_FUNDRAISER_PAGE_TITLE':
            return {
                ...state,
                validate_fd_page_title: action.validate_fd_page_title
            };
        default:
            return state
    }
}

export function get_users_except_lead(state = initialState, action) {
    switch (action.type) {
        case 'GET_ALL_USERS_EXCEPT_FUND_RAISER_PAGE_LEAD':
            return {
                ...state,
                users_except_lead: action.users_except_lead
            };
        default:
            return state
    }
}

export function get_all_team_members(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_TEAM_MEMBERS':
            state.redux_loader = false;
            return {
                ...state,
                team: action.team
            };
        default:
            return state
    }
}

export function get_all_team_members_with_pagination(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_TEAM_MEMBERS_WITH_PAGINATION':
            state.redux_loader = false;
            return {
                ...state,
                team: action.team
            };
        default:
            return state
    }
}

export function get_active_team_members(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ACTIVE_TEAM_MEMBERS':
            state.redux_loader = false;
            return {
                ...state,
                active_team_members: action.active_team_members
            };
        default:
            return state
    }
}
export function team_members_list_by_user(state = initialState, action) {
    switch (action.type) {
        case 'TEAM_MEMBERS_BY_USER':
            return {
                //...state,
                team_members_by_user: action.team_members_by_user
            };
        default:
            return state
    }
}

export function get_all_fundraiser_page_donors(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_FUNDRAISER_PAGE_DONORS':
            return {
                ...state,
                donors: action.donors
            };
        default:
            return state
    }
}

export function get_all_fundraiser_page_mostrecent_donations(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_FUNDRAISER_PAGE_MOST_RECENT_DONATIONS':
            if (action.offset > 0)
                return {
                    ...state,
                    recentDonations: {
                        ...state.recentDonations,
                        donations: [
                            ...state.recentDonations.donations,
                            ...action.donors.recent_donations
                        ],
                    }
                }
            else return {
                ...state,
                recentDonations: {
                    donations: action.donors.recent_donations,
                    totalDonations: action.donors.total_donations
                }
            };
        default:
            return state
    }
}

export function get_all_fundraiser_page_most_donations(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_FUNDRAISER_PAGE_MOST_DONATIONS':
            if (action.offset > 0)
                return {
                    ...state,
                    highestDonations: {
                        ...state.highestDonations,
                        donations: [
                            ...state.highestDonations.donations,
                            ...action.donors.most_donations
                        ],
                    }
                }
            else return {
                ...state,
                highestDonations: {
                    donations: action.donors.most_donations,
                    totalDonations: action.donors.total_donations
                }
            };
        default:
            return state
    }
}

export function get_teams_fund_stat(state = initialState, action) {
    switch (action.type) {
        case 'RECENT_TEAMS_STAT':
            return {
                //...state,
                recent_teams_stat: action.recent_teams_stat
            };
        default:
            return state
    }
}

export function get_event_id(state = initialState, action) {
    switch (action.type) {
        case 'EVENT_ID':
            return {
                //...state,
                event_id: action.event_id
            };
        default:
            return state
    }
}

export function add_updates_as_description_or_images(state = initialState, action) {
    switch (action.type) {
        case 'ADD_UPDATES_AS_DESCRIPTION_OR_IMAGES':
            state.redux_loader = false;
            return {
                ...state,
                cover_images: action.cover_images
            };
        default:
            return state
    }
}
